/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dateTime: NonNullable<unknown> }} Coinvestments_Senddrafts_Scheduledbadge3Inputs */

const en_coinvestments_senddrafts_scheduledbadge3 = /** @type {(inputs: Coinvestments_Senddrafts_Scheduledbadge3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scheduled · ${i?.dateTime}`)
};

/**
* | output |
* | --- |
* | "Scheduled · {dateTime}" |
*
* @param {Coinvestments_Senddrafts_Scheduledbadge3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_scheduledbadge3 = /** @type {((inputs: Coinvestments_Senddrafts_Scheduledbadge3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Scheduledbadge3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_scheduledbadge3(inputs)
});
export { coinvestments_senddrafts_scheduledbadge3 as "coInvestments_sendDrafts_scheduledBadge" }